<template>
  <div class="carousel">
    <el-carousel :autoplay="true" trigger="click" height="810px">
      <el-carousel-item v-for="(imgUrl,i) in imgUrlsL" :key="i">
        <center> <img :src="imgUrl" style="width: 100%;"> </center>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data () {
    return {
      imgUrlsL: [],
    }
  },
  created() {
    this.$http.get("api/vue_config/carousel_imgs").then((response) => {
      // console.log(response.data.data)
      this.imgUrlsL = JSON.parse(response.data.data)
    });

  },
  
};
</script>

<style lang="less" scoped>

.carousel{margin: 10px 10px;}

</style>
